const styles = {
  container: {
    padding: '0 !important',
    fontSize: '0.875rem !important',
    color: '#646464 !important',
    fontFamily: 'DOSH !important',
    fontWeight: 'normal !important',
  },
  tableContainer: {
    margin: '0.625rem',
    padding: 0,
    border: '0.0625rem solid #e5e5e5',
    borderRadius: '0.3125rem',
  },
  header: {
    fontSize: '1.875rem !important',
    fontWeight: 'normal !important' as 'normal',
    marginTop: '0 !important',
  },
  dateLabel: {
    display: 'block !important',
    fontFamily: 'DOSH !important',
    color: '#4a4a4a !important',
    fontWeight: '400 !important',
  },
  label: {
    fontFamily: 'DOSH !important',
    color: '#4a4a4a !important',
    fontWeight: '400 !important',
  },
  tableHeader: {
    backgroundColor: '#ffffff !important',
    color: '#646464 !important',
    fontSize: '0.875rem !important',
    fontWeight: '400 !important',
    fontFamily: 'DOSH !important',
    border: 'none !important;',
    borderBottom: '0.0625rem solid rgba(34,36,38,.1) !important',
  },
  clickable: {
    cursor: 'pointer',
  },
  selectableRow: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  '@global @media only screen and (min-width:1200px)': {
    '.ui.container': {
      width: '82.938rem',
      marginLeft: '0 !important',
      marginRight: 'auto!important',
    },
  },
  formError: {
    padding: '1rem',
  },
};

export default styles;
